// extracted by mini-css-extract-plugin
export default {"groups":"fzEEQGFe0kKQ8GbxjuNn"};